import React from 'react';
import { ClassAssembly4E2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly4E2026/>;
  };
  
  export default ClassAssemblyPage;